module.exports = __webpack_public_path__ + "static/media/ednaBurial08.dbdeabf2.png";